import { api } from "./axios";

export const adminApi = {
  getUsers: ({ page = 1, limit = 10, search = "", searchType = "name" } = {}) =>
    api.get(`/admin/get-all-users`, {
      params: {
        page,
        limit,
        search,
        searchType,
      },
    }),

  inviteUser: (data: { email: string; label: string }) =>
    api.post("/admin/invite-user", data),

  createPitch: (data: { title: string; description: string }) =>
    api.post("/admin/pitches", data),

  deleteUser: (userId: number) => api.post(`/admin/remove-user`, { userId }),

  promoteUser: (userId: number) => api.post(`/admin/promote-user`, { userId }),

  addLabel: (data: { name: string; type?: string; availableDSPs: string[] }) =>
    api.post("/admin/add-label", data),

  getLabels: () => api.get("/admin/get-labels"),

  updateLabel: (
    id: number,
    {
      name,
      type,
      availableDSPs,
    }: { name: string; type: string; availableDSPs: string[] }
  ) => api.put(`/admin/update-label/${id}`, { name, type, availableDSPs }),
};
